import {IComponentOptions} from "angular";
import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";


export class DateEditableField extends IEditableField {
    public static instance: IComponentOptions = getEditableFieldConfiguration(
        require('./date-editable-field.component.html'),
        [DateEditableField]
    );

    static readonly DEFAULT_ERROR_MESSAGE = 'Should follow the date pattern yyyy-MM-dd';

    $onInit() {
        this.errorMessage = DateEditableField.DEFAULT_ERROR_MESSAGE;
    }

}